module.exports = __webpack_public_path__ + "static/img/faceCourse.fdac0e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/faceCourse.png
// module id = KC5t
// module chunks = 20